import { render, staticRenderFns } from "./TorAbschlussSimulierenModal.vue?vue&type=template&id=1923f278"
import script from "./TorAbschlussSimulierenModal.vue?vue&type=script&lang=js"
export * from "./TorAbschlussSimulierenModal.vue?vue&type=script&lang=js"
import style0 from "./TorAbschlussSimulierenModal.vue?vue&type=style&index=0&id=1923f278&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports